// PrivateRoute.js
import React from 'react';
import { Navigate, Route } from 'react-router-dom';

const PrivateRoute = ({ element: Element, authenticated, ...rest }) => {
  return authenticated ? <Element {...rest} /> : <Navigate to="/register" />;
};

export default PrivateRoute;
